module.exports = __webpack_public_path__ + "img/employee.c718e553.png";